import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    this.boundAppendToken = this.appendToken.bind(this)
    document.addEventListener("turbo:before-fetch-request", this.boundAppendToken)
  }

  disconnect () {
    document.removeEventListener("turbo:before-fetch-request", this.boundAppendToken)
  }

  appendToken (event) {
    const token = this.element.querySelector('meta[name="lms-session-token"]')?.content
    if (!token) return

    const url = event.detail.url

    try {
      url.searchParams.set("lms_session_token", token)
    } catch {
      // Safari blocks searchParams access in cross-origin iframe contexts
      if (!url.href.includes("lms_session_token=")) {
        const separator = url.href.includes("?") ? "&" : "?"
        url.href = url.href + separator + "lms_session_token=" + encodeURIComponent(token)
      }
    }
  }
}
